module.exports = __webpack_public_path__ + "img/4.55a0bc34.jpg";